import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-jb-color-picker-demo',
  templateUrl: './jb-color-picker-demo.component.html',
  styleUrls: ['./jb-color-picker-demo.component.scss']
})
export class JbColorPickerDemoComponent implements OnInit {
  public name = jbColorPickerDoc.name;
  public desc = jbColorPickerDoc.desc;
  public api = jbColorPickerDoc.api;
  public instance = jbColorPickerDoc.instance;
  public colorValue = '731573';

  public cssReset = `
  $color-picker-gray-dark: #333 !default
  `;

  // ---- This is the logic to manage autogenerated code example ----
  public brStr = `\n`;
  public bsStr = `\n             `;
  public customCompCode = `<jb-color-picker [jbColor]="color" (jbColorChange)="onColorChanged($event)"></jb-color-picker>`;
  public compConf: any = {
    color: '731573'
  };
  public upComp = () => {
    this.customCompCode = `<jb-color-picker `;

    let compClasses = '';
    if (this.compConf.hasFullWidth) { compClasses += (!!compClasses.length ? ' ' : '') + 'full-width'; }
    if (this.compConf.hasSquash)    { compClasses += (!!compClasses.length ? ' ' : '') + 'squash'; }
    if (!!compClasses) {
      this.customCompCode += `class="${compClasses}"` + this.bsStr;
    }
    this.customCompCode += `(jbColor)="myVal"` + this.bsStr;
    this.customCompCode += `(jbColorChange)="doSomething($event)"`;
    this.customCompCode += (`>` + this.brStr + `</jb-color-picker>`);
  };

  constructor() { }

  ngOnInit() { }

  onColorChanged(color: string): void {
    this.colorValue = color;
  }

}

export const jbColorPickerDoc = {
  name    : `jb-color-picker`,
  uiType  : 'component',
  desc    : `Generates a color picker`,
  api     : `[jbColor]: The initial color value, if empty will default to #00000
(jbColorChange): An event emitted when the color has changed`,
  instance: `<jb-color-picker jbColor="731573" (jbColorChange)="onColorChanged($event)"></jb-color-picker>`,
  demoComp: JbColorPickerDemoComponent
};
